import React, { useEffect, useRef, useState } from 'react';
import '@/pages/intelligence/assets/scss/iMurReports/index.scss';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { Icon, Justify, Layout, SearchBox, Segment, Select } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import useData from './_hooks';
import useConfig from './_config';
import './index.scss';
import '@/pages/intelligence/components/LazyReport/index.scss';
import ReportCard from '../../components/ReportCard';
import { useIntl } from 'umi';
import moment from 'moment';
import Loading from '@/pages/intelligence/components/Loading';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

import { IS_GLOBAL } from '@/pages/home/_config/config';

import { debounce } from 'lodash-es';
const { Content } = Layout;

const NEW_MARK_IDS_MAPPING_KEY = 'ReportsIMurReports';

export default function iMurReports(props) {
  const { formatMessage } = useIntl();

  const {
    dataAfterSearch,
    activeId,
    setActiveId,
    dataLoading,
    segmentValue,
    setSegmentValue,
    type,
    setType,
    searchValue,
    setSearchValue,
    debounceSearchChange,
    lazyScrollRef,
    data,
    loading,
    loadingMore,
    noMore,
  } = useData(props);

  const { SegmentList, optionData, tabs } = useConfig();

  const onActive = (tab: { id: any }) => {
    setActiveId(tab.id);
    if (dbiPageLogMes?.[tab?.pagePoint]) {
      buriedPointPage(dbiPageLogMes?.[tab?.pagePoint]);
    }
  };
  const scrollBody = useRef(null);
  const [tabFixed, setTabFixed] = useState(false);

  // 监听页面滚动
  useEffect(() => {
    if (scrollBody.current) {
      const handleScroll = debounce((e: any) => {
        const { scrollTop } = e.srcElement;
        // console.log(scrollTop);

        // 滚动判断距离 和定位条位置相关，开发调整
        if (scrollTop > 260) {
          setTabFixed(true);
        } else {
          setTabFixed(false);
        }
      }, 100);
      scrollBody.current?.addEventListener('scroll', handleScroll, false);
      return () => scrollBody.current?.removeEventListener('scroll', handleScroll, false);
    }
  }, [scrollBody]);
  return (
    <Content className="dbi-imurreports" ref={scrollBody}>
      <Content.Header
        className="dbi-header contentHead-normal dbi-header-des"
        title={formatMessage({ id: 'dbi_imur_reports' })}
      >
        <div className="header-des">
          <span className="header-des-text">
            {formatMessage({
              id: IS_GLOBAL ? 'dbi_imur_reports_intro_global' : 'dbi_imur_reports_intro',
            })}
          </span>
        </div>
        <div className="header-tab">
          <Tabs
            ceiling
            newMarkIdsMappingKey={NEW_MARK_IDS_MAPPING_KEY}
            tabs={tabs}
            animated={false}
            activeId={activeId}
            onActive={onActive}
          />
        </div>
      </Content.Header>

      <Content.Body full ref={lazyScrollRef} className="dbi-imur-full">
        <MarqueeBanner />
        {/* 吸顶内容 */}
        <div className={`header-fixedtab ${tabFixed ? 'visible' : 'hide'}`}>
          <div className="header-tab">
            <Tabs
              ceiling
              newMarkIdsMappingKey={NEW_MARK_IDS_MAPPING_KEY}
              tabs={tabs}
              animated={false}
              activeId={activeId}
              onActive={onActive}
            />
          </div>
        </div>

        <div className="dbi-imur-filterheader">
          {SegmentList[activeId] && (
            <Segment
              className="segment-light"
              value={segmentValue}
              onChange={(value: any) => setSegmentValue(value)}
              options={SegmentList[activeId]}
            />
          )}
          <Justify
            className="dbi-imurreports-justify"
            left={
              <Select
                className="select-item"
                appearance="button"
                options={optionData}
                value={type}
                matchButtonWidth
                onChange={(value: any) => {
                  setType(value);
                }}
                button={() => (
                  <div className="select-button">
                    <div className="select-button-text">
                      {formatMessage({ id: 'dbi_imur_reports_report_type' })}
                    </div>
                    {
                      optionData.filter((e) => {
                        return e.value === type;
                      })[0]?.text
                    }
                  </div>
                )}
              />
            }
            right={
              <SearchBox
                className="edit-search-box"
                value={searchValue}
                onChange={(word) => {
                  if (word.trim() !== searchValue) {
                    // console.log("diff")
                    setSearchValue(word.trim());
                    debounceSearchChange(word.trim());
                  }
                }}
                placeholder={formatMessage({
                  id: 'dbi_reports_search_placeholder',
                })}
              />
            }
          />
        </div>
        {loading ? (
          <div style={{ height: 'calc(100vh - 300px)', color: '#262832' }}>
            <Loading content={formatMessage({ id: 'common_loading' })} />
          </div>
        ) : (
          // {loading ? (
          //   <div className="dbi-lazyreport-loading">
          //     <Icon size="l" type="loading" />
          //     &nbsp;&nbsp;&nbsp;{formatMessage({ id: 'dbi_reports_loading' })}
          //   </div>
          <div>
            {data?.list?.map((item, index) => {
              return (
                <ReportCard
                  hasPDF={false}
                  key={index}
                  data={item}
                  isMur
                  isNew={!!moment(item?.time).isAfter(moment().subtract(1, 'month'))}
                  reportLangSegment={segmentValue}
                />
              );
            })}
          </div>
        )}
        {loadingMore && (
          <div className="dbi-lazyreport-loading dbi-lazyreport-end">
            <Icon size="l" type="loading" />
            &nbsp;&nbsp;&nbsp;
            {formatMessage({ id: 'dbi_reports_loading_more' })}
          </div>
        )}
        {dataAfterSearch.length <= 0 && noMore && !loading && !dataLoading && (
          <div className="dbi-reportcard-nodata dbi-lazy-nodata dbi-imur-nodata">
            {formatMessage({ id: 'dbi_reports_no_data' })}
          </div>
        )}
      </Content.Body>
    </Content>
  );
}
